/**
 * Versione corrente del progetto Kyloo.
 *
 * Sincronizzata con il file `/app/VERSION` e `/app/CHANGELOG.md`. Esposta
 * anche tramite `GET /api/version` per controlli runtime.
 *
 * Bumpare la versione in QUESTA costante quando si fa una modifica significativa,
 * aggiornare allo stesso tempo il file `/app/VERSION` (single source of truth)
 * e aggiungere un'entry in CHANGELOG.md.
 */
export const KYLOO_VERSION = 'v1.8.8';
